// DownloadButton.jsx
import React, { useState } from "react";
import EmailModal from "./EmailModal";

const DownloadButton = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleDownloadClick = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div style={{
      margin: "1rem 0"
    }}>
      <button onClick={handleDownloadClick}>Download Work Presentation</button>
      {modalOpen && (
        <EmailModal
          onClose={closeModal}
          filePath={`${process.env.PUBLIC_URL}/files/work`}
          fileName="Aryan_D_Sheth_Work_Presentation.pptx"
          submissionRoute="work-presentation-emails"
        />
      )}
    </div>
  );
};

export default DownloadButton;
